<form [formGroup]="resetPasswordForm" (ngSubmit)="resetPassword()">
  <div class="row">
    <div class="form-group col-md-6">
      <label>New password</label>
      <div class="input-group">
        <input class="form-control" [ngClass]="setClassInvalid(resetPasswordForm, 'password')" [type]="inputPasswordType" name="password"
               formControlName="password" placeholder="New password" minlength="6" required>
        <div class="input-group-append cursor-pointer" (click)="toggleInputPasswordType()"
            data-bs-toggle="tooltip" data-placement="top" data-delay="350" title="Show/Hide password">
          <span class="input-group-text">
            <i class="fa" [ngClass]="{'fa-eye': inputPasswordType === 'password', 'fa-eye-slash': inputPasswordType === 'text' }"></i>
          </span>
        </div>
        <div class="invalid-feedback">Password must be 8+ characters.</div>
      </div>
    </div>
  </div>
  <button class="btn btn-primary" type="submit" [disabled]="!resetPasswordForm.valid">
    <i class="fa fa-floppy-o"></i> Save
  </button>
</form>